module.exports = __webpack_public_path__ + "img/04.b753c105.png";